import { getCurrentThemeId } from 'owa-theme';
import { ThemeConstants } from 'owa-theme-shared';
import generateSuitePaletteFromFabricPalette from './generateSuitePaletteFromFabricPalette';
import React from 'react';
import {
    BASE_LIGHT_THEME_PALETTE,
    OFFICENEUTRAL_LIGHT_THEME_PALETTE_DIFF_BASE,
} from 'owa-theme-common';
import type { BaseTheme } from '@1js/suiteux-shell-react';

export default function useOwaBrandTheme(): BaseTheme {
    /**
     * When the UserThemeId is set to 'base', the Shell uses an AppBrandTheme palette, if provided.
     * This will be taken from the OWA theme definition with Id 'base'.
     * OfficeNeutral theme Id will be used as the AppBrandTheme if OfficeNeutral is selected
     */
    const themeId = getCurrentThemeId();

    return React.useMemo(() => {
        return themeId === ThemeConstants.OFFICE_NEUTRAL_THEME_ID ||
            themeId === ThemeConstants.MODERN_OFFICE_NEUTRAL_THEME_ID
            ? generateSuitePaletteFromFabricPalette({
                  ...BASE_LIGHT_THEME_PALETTE,
                  ...OFFICENEUTRAL_LIGHT_THEME_PALETTE_DIFF_BASE,
              })
            : generateSuitePaletteFromFabricPalette(BASE_LIGHT_THEME_PALETTE);
    }, [themeId]);
}
